module.exports = __webpack_public_path__ + "img/bg01.65a8fc79.png";